// extracted by mini-css-extract-plugin
module.exports = {"container":"faq_container__bq0EV","headline":"faq_headline__DVatf","content-wrapper":"faq_content-wrapper__Uotre","contentWrapper":"faq_content-wrapper__Uotre"};